import { getReportUrl } from "@via/pages/projects/runs/reports/utils/helpers.ts";
import { RunReportResource } from "common";
import { JSX } from "react";

export function DisplayableReport({
  report,
}: {
  report: RunReportResource;
}): JSX.Element {
  const url = getReportUrl(report?.routePath);

  return <iframe className="h-full w-full" src={url} />;
}
